const css = `
<style>
body { font-family: Arial, sans-serif; margin: 40px; line-height: 1.6;}
h1 { text-align: center; text-transform: uppercase;}
p { margin: 1rem 0}
.header { margin-bottom: 30px;}
.section { margin-bottom: 20px;}
.footer { font-size: 0.9em; color: #555;}
table { width: 100%; border-collapse: collapse; margin-top: 20px; font-size: 0.95em;}
th,td { border: 1px solid #000; padding: 8px 12px; text-align: left;}
th { background-color: #f0f0f0;}
</style>
`;

export default css;
